import React from 'react';
import Icon from '../icon/Icon';
import classNames from 'classnames';
var DropdownItemLabel = function(param) {
    var icon = param.icon, label = param.label, className = param.className;
    return /*#__PURE__*/ React.createElement("span", {
        className: classNames('DropdownItemLabel', className)
    }, icon && /*#__PURE__*/ React.createElement(Icon, {
        icon: icon
    }), label);
};
export default DropdownItemLabel;
